import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const APP_LOADED = 'appLoaded';

export const setAppLoaded = createAction(APP_LOADED);
